<form [formGroup]="mortDetailFrmGrp">
    <div class="row no-gutters content_top_margin bot_spa_aft_sect_heading" *ngIf="listOfMortgage.length>0">
        <div class="col-12 d-flex align-items-lg-center">
            <span role="radiogroup" id="lblCustRelationRadio" class="sectionHeading_one">{{
                'mortgage_detail.title'
                |translate }}<button type="button" id="btnttltip" class="ml-2 infoButton p-0"
                    (click)="$event.stopPropagation();setPopOver('header')" #ert="ngbPopover" [autoClose]="true"
                    [ngbPopover]="popContent" popoverClass="custom-popover" placement="bottom"
                    [attr.aria-label]="'mortgage_detail.mortgagePopupSr'|translate">
                    <img aria-hidden="true" src="./assets/icons/helpIcon.svg" alt="helpIcon-icon" class="pb-1"
                        role="dialog"></button>
            </span>
        </div>
    </div>
    <ng-container *ngIf="listOfMortgage.length>0">
        <div role="table">
            <div class="row no-gutters d-lg-flex d-none border border-top-radius p-3" role="row">
                <div class="col-1" role="columnheader"></div>
                <div class="col-3 text-center" role="columnheader"><b>{{'mortgage_detail.current_balance'|translate}}</b></div>
                <div class="col-3 text-center" role="columnheader"><b>{{'mortgage_detail.credit_limit'|translate}}</b></div>
                <div class="col-5 text-center" role="columnheader"><b>{{'mortgage_detail.financial_institution'|translate}}</b></div>
            </div>
            <ng-container *ngFor="let list of listOfMortgage;let i=index;let isLast=last">
                <div class="row no-gutters d-flex flex-column flex-lg-row  border border-top-0 p-lg-3 p-0   mb-lg-0 mb-3"
                    [ngClass]="isLast?'border-bottom-radius':''" role="row">
                    <div class="col-lg-1 col-12 d-flex  border-top-radius-mob   p-3 p-lg-0" role="cell">
                        <label class="checkboxAlignment field_lable_bot_margin_unset">
                            <input class="wdd-fl border-cls" id="checked{{i}}" type="checkbox"
                                formControlName="checked{{i}}" [attr.aria-label]="'mortgage_detail.checked'|translate"
                                aria-describedby="checkBoxHelp" aria-required="true">
                            <span class="checkmark" [ngClass]="displayValidation?'':'invalidBorder'"></span>
                        </label>
                        <span class="d-block d-lg-none ml-2">Select</span>
                    </div>
                    <div
                        class="col-lg-3 col-12 d-flex   justify-content-between align-items-lg-start justify-content-lg-center p-3 p-lg-0" role="cell">
                        <span class="d-lg-none d-block"><b>{{'mortgage_detail.current_balance'|translate}}</b></span>
                        <span>{{list.outstandingBalance| currency :
                            'CAD' : 'symbol-narrow' : '1.0-2' :currentLang}}</span>
                    </div>
                    <div class="col-12 px-3 d-block d-lg-none ">
                        <div class="borderLine"></div>
                    </div>
                    <div
                        class="col-lg-3 col-12 d-flex  justify-content-between align-items-lg-start justify-content-lg-center p-3 p-lg-0" role="cell">
                        <span class="d-lg-none d-block"><b>{{'mortgage_detail.credit_limit'|translate}}</b></span>
                        <span *ngIf="list.creditLimit!=undefined||list.creditLimit!=null">{{list.creditLimit | currency
                            :
                            'CAD'
                            :'symbol-narrow' : '1.0-2' :currentLang}}</span>
                        <span *ngIf="list.creditLimit==undefined||list.creditLimit==null">-</span>
                        <!-- <div class="borderLine"></div> -->

                    </div>
                    <div class="col-12 px-3 d-block d-lg-none">
                        <div class="borderLine"></div>
                    </div>
                    <div
                        class="col-lg-5 col-12 d-flex flex-column p-3 p-lg-0  align-items-lg-start justify-content-lg-center" role="cell">
                        <span
                            class="d-lg-none d-block field_heading_minHeight_label d-flex align-items-center"><b>{{'mortgage_detail.financial_institution'|translate}}</b></span>
                        <ng-container *ngIf="list.companyName"><span>{{list.companyName}}</span></ng-container>
                        <ng-container *ngIf="list.companyName==null">
                            <select name="" id="" formControlName="mortgageProviderControl{{i}}" aria-required="true"
                                class="nonSelectBorder wdd-fl border-cls"
                                [attr.aria-label]="'mortgage_detail.financial_institution'|translate"
                                [ngClass]="checked[i]==true&&selectedMortgageProvider[i]==''&&isSubmitted?'invalidBorder':''">
                                <option value="">{{'mortgage_detail.selectOne'|translate}}</option>
                                <ng-container *ngIf="currentLang=='en'">
                                    <option *ngFor="let provider of mortgageProvider" [value]="provider.en">
                                        {{provider.en}}
                                    </option>
                                </ng-container>
                                <ng-container *ngIf="currentLang=='fr'">
                                    <option *ngFor="let provider of mortgageProvider" [value]="provider.fr">
                                        {{provider.fr}}
                                    </option>
                                </ng-container>
                            </select>
                            <div *ngIf="checked[i]==true&&selectedMortgageProvider[i]==''&&isSubmitted">
                                {{'mortgage_detail.financialInstErrMsg'|translate}}</div>
                            <div class="w-100 top_spa_aft_sect_heading"
                                *ngIf="mortDetailFrmGrp.get('mortgageProviderControl'+i)?.value===notListedEn||mortDetailFrmGrp.get('mortgageProviderControl'+i)?.value===notListedFr">
                                <p
                                    class="m-0 field_heading_minHeight_label d-flex align-items-center justify-content-lg-center">
                                    <b>{{'mortgage_detail.financial_institution_name'|translate}}</b>
                                </p>
                                <input type="text" id="newProvider" formControlName="newProvider{{i}}"
                                    class="nonSelectBorder wdd-fl border-cls"
                                    [attr.aria-label]="'mortgage_detail.financial_institution_name'|translate"
                                    [ngClass]="mortDetailFrmGrp.get('newProvider'+i)?.invalid&&isSubmitted&&checked[i]==true?'invalidBorder':'nonSelectBorder'"
                                    aria-required="true">

                                <div class="mt-2"
                                    *ngIf="isSubmitted && mortDetailFrmGrp.get('newProvider'+i)?.invalid&&checked[i]==true">
                                    {{ 'mortgage_detail.financialInstProvMsg' | translate }}
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>
        </div>
    </ng-container>


    
    <div class="row no-gutters space_between_section_top bot_spa_aft_sect_heading">
        <div class="col-12" *ngIf="listOfMortgage.length>0">
            <span class="sectionHeading_one">
                {{'mortgage_detail.notlisted'|translate}}
            </span>
        </div>
        <div class="col-12" *ngIf="listOfMortgage.length==0">
            <span class="sectionHeading_one">
                {{'mortgage_detail.manualLiab'|translate}}
            </span>
        </div>
    </div>
    <div class="row no-gutters bot_spa_aft_sect_heading d-lg-flex d-none">
        <div *ngIf="listOfMortgage.length>0" class="col-1"></div>
        <div class="col-lg-5 col-lg-4 text-center">
            <span class="d-lg-block d-none"><b>{{'mortgage_detail.current_balance'|translate}}</b><button type="button"
                    id="btnttltip" class="ml-2 infoButton"
                    [attr.aria-label]="'mortgage_detail.currentBalanceSr'|translate"
                    (click)="$event.stopPropagation();setPopOver('currentBalance')" #ert="ngbPopover" [autoClose]="true"
                    [ngbPopover]="popContent" popoverClass="custom-popover" placement="bottom">
                    <img aria-hidden="true" src="./assets/icons/helpIcon.svg" alt="helpIcon-icon" class="pb-1"
                        role="dialog"></button>
            </span>
        </div>
        <div class="col-lg-5 text-center space_between_field">
            <span class="d-lg-block d-none"><b>{{'mortgage_detail.financial_institution'|translate}}</b></span>
        </div>
    </div>
    <div [ngClass]="listOfMortgage.length==0?'row no-gutters border_mob  px-lg-0 p-0':'row no-gutters border_mob  px-lg-3 p-0'"
        role="row">
        <div *ngIf="listOfMortgage.length>0" class="col-lg-1 col-12 d-flex p-3 p-lg-0 border-top-radius-mob"
            role="cell">
            <label class="checkboxAlignment field_lable_bot_margin_unset">
                <input id="checkedManual" type="checkbox" formControlName="checkedManual" [checked]="isValue"
                    [attr.aria-label]="'mortgage_detail.checked'|translate" aria-describedby="checkBoxHelp"
                    aria-required="true">
                <span class="outsideChk checkmark" [ngClass]="displayValidation?'':'invalidBorder'"
                    *ngIf="listOfMortgage.length>0"></span>
            </label>
            <span class="ml-2 d-block d-lg-none">Select</span>
        </div>
        <div class="col-lg-5 col-lg-4 col-12 p-3 p-lg-0 d-flex flex-column   align-items-start " role="cell">
            <span
                class="d-lg-none d-block field_heading_minHeight_label d-flex align-items-center"><b>{{'mortgage_detail.current_balance'|translate}}</b><button
                    type="button" id="btnttltip" class="ml-2 infoButton"
                    [attr.aria-label]="'mortgage_detail.currentBalanceSr'|translate"
                    (click)="$event.stopPropagation();setPopOver('currentBalance')" #ert="ngbPopover" [autoClose]="true"
                    [ngbPopover]="popContent" popoverClass="custom-popover" placement="bottom">
                    <img aria-hidden="true" src="./assets/icons/helpIcon.svg" alt="helpIcon-icon" class="pb-1"
                        role="dialog"></button>
            </span>
            <ng-container *ngIf="currentLang=='en'">
                <input type="text" id="estimatedAmount" app formControlName="estimatedAmount"
                    Class="nonSelectBorder wdd-fl border-cls" appMycurrency aria-describedby="" autocomplete="off"
                    [attr.aria-label]="'mortgage_detail.current_balance'|translate"
                    [ngClass]="(isSubmitted||mortDetailFrmGrp?.controls?.estimatedAmount?.touched)&&manualCheck&&mortDetailFrmGrp.get('estimatedAmount')?.invalid?'invalidBorder':''"
                    maxlength="9" aria-required="true">
            </ng-container>
            <ng-container *ngIf="currentLang=='fr'">
                <div class="input-wrapper w-100">
                    <input type="text" id="estimatedAmount" app formControlName="estimatedAmount"
                        Class="nonSelectBorder wdd-fl border-cls" appMycurrencyFr aria-describedby="" autocomplete="off"
                        [attr.aria-label]="'mortgage_detail.current_balance'|translate"
                        [ngClass]="(isSubmitted||mortDetailFrmGrp?.controls?.estimatedAmount?.touched)&&manualCheck&&mortDetailFrmGrp.get('estimatedAmount')?.invalid?'invalidBorder':''"
                        maxlength="7" aria-required="true">
                    <div class="iconAlignT" *ngIf="currentLang == 'fr'">
                        <span id="basic-addon2">$</span>
                    </div>
                </div>
            </ng-container>
            <div class="top_spa_aft_sect_heading"
                *ngIf="(isSubmitted||mortDetailFrmGrp?.controls?.estimatedAmount?.touched)&&manualCheck&&mortDetailFrmGrp.get('estimatedAmount')?.invalid">
                {{'mortgage_detail.currentBalanceErrMsg'|translate}}
            </div>
            <!-- <div class="borderLine"></div> -->
        </div>
        <div class="col-12 px-3 d-block d-lg-none">
            <div class="borderLine"></div>
        </div>
        <div class="col-lg-5 col-12 px-3 p-lg-0 d-flex flex-column  align-items-start   px-3 bot_spa_aft_mobile_sec_heading space_between_field"
            role="cell">
            <span
                class="d-lg-none d-block d-flex align-items-center field_heading_minHeight_label"><b>{{'mortgage_detail.financial_institution'|translate}}</b></span>
            <select formControlName="mrtgManualProvider" aria-required="true" id="financeIns"
                class=" nonSelectBorder wdd-fl border-cls"
                [attr.aria-label]="'mortgage_detail.financial_institution'|translate"
                [ngClass]="isSubmitted&&manualCheck&&mortDetailFrmGrp.get('mrtgManualProvider')?.invalid?'invalidBorder':''">
                <option value="" style="color:grey">{{'mortgage_detail.selectOne'|translate}}</option>
                <ng-container *ngIf="currentLang=='en'">
                    <option *ngFor="let provider of mortgageProvider" [value]="provider.en">{{provider.en}}
                    </option>
                </ng-container>
                <ng-container *ngIf="currentLang=='fr'">
                    <option *ngFor="let provider of mortgageProvider" [value]="provider.fr">{{provider.fr}}
                    </option>
                </ng-container>
            </select>
            <div *ngIf="manualProvider==notListedEn||manualProvider==notListedFr" class="w-100 ">
                <p
                    class="mt-2 mb-0 finameNotListed d-flex align-items-center justify-content-lg-center field_heading_minHeight_label">
                    <b>{{'mortgage_detail.financial_institution_name'|translate}}</b>
                </p>
                <input type="text" id="manualProviderName" formControlName="manualProviderName"
                    Class="nonSelectBorder wdd-fl border-cls finameNot"
                    [attr.aria-label]="'mortgage_detail.financial_institution_name'|translate"
                    [ngClass]="isSubmitted&&manualCheck&&mortDetailFrmGrp.get('manualProviderName')?.invalid?'invalidBorder':''"
                    aria-required="true">


                <div class="top_spa_aft_sect_heading"
                    *ngIf="isSubmitted && mortDetailFrmGrp.get('manualProviderName')?.invalid&&manualCheck">
                    {{ 'mortgage_detail.financialInstProvMsg' | translate }}
                </div>

            </div>
            <div class="top_spa_aft_sect_heading"
                *ngIf="isSubmitted&&manualCheck&&mortDetailFrmGrp.get('mrtgManualProvider')?.invalid">
                {{'mortgage_detail.financialInstErrMsg'|translate}}
            </div>
        </div>
    </div>
    <div class="row no-gutters top_spa_aft_sect_heading" *ngIf="!displayValidation||balanceError">
        <div class="col-12">
            <small id="checkBoxHelp" class="d-flex align-items-start mt-1 errorMsg"> <img aria-hidden="true"
                    src="./assets/images/menu_icons/Alert.svg" alt=""> <span class="ml-2">
                    <ng-container *ngIf="!displayValidation">
                        {{'mortgage_detail.errorMsg'|translate}}
                    </ng-container>
                    <ng-container *ngIf="balanceError">
                        {{'mortgage_detail.balanceerrorMsg'|translate}}
                    </ng-container>
                </span>
            </small>
        </div>
    </div>
    <div class="row no-gutters top_height_actionButton content_top_mobile_margin">
        <div class="col-12 d-flex d-md-block flex-column-reverse">
            <cancel-button></cancel-button>
            <button type="button" class="common_btn saveNextBtn_features space_between_button"
                (click)="onContinue()">{{'buttonallpages.continuelable' | translate }}</button>
        </div>
    </div>
</form>
<ng-template #popContent class="popContent">
    <div role="dialog" cdkTrapFocus [cdkTrapFocusAutoCapture]="true" class="tooltip-content">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" data-toggle="tooltip"
            data-placement="top">
            <span class="popUpClose" aria-hidden="true">&times;</span>
            <span class="show-for-sr">{{'persInfo.close' | translate}}</span>
        </button>
        <div class="modal-body p-3">
            <ng-container *ngIf="popOverType=='header'">
                {{ 'mortgage_detail.not_list_info' | translate }}
            </ng-container>
            <ng-container *ngIf="popOverType=='currentBalance'">
                {{ 'mortgage_detail.currentBalancePopup' | translate }}
            </ng-container>
        </div>
    </div>
</ng-template>